import React, { useMemo } from 'react';
import cardUtils from '../../utils/cardUtils';
import formatter from '../../utils/formatter';

/**
 * What the whole decklist costs at CardKingdom reference prices, commander and
 * basic lands included. Rendered as a single line directly under the commander's
 * own price, so it is styled to match that line rather than as a panel.
 */
const DeckPrice = ({ deckCards, quantities, ckPrices }) => {
  const { total, cardsWithoutPrice } = useMemo(() => {
    let sum = 0;
    let missing = 0;

    deckCards.forEach(card => {
      const price =
        cardUtils.cardKingdomPrice(card) ??
        (ckPrices ? ckPrices[card.name] : null);
      if (!price) {
        missing += 1;
        return;
      }
      sum += price * (quantities[card.name.toLowerCase()] || 1);
    });

    return { total: sum, cardsWithoutPrice: missing };
  }, [deckCards, quantities, ckPrices]);

  return (
    <p className="text-sm">
      <i className="fas fa-tag mr-2"></i>
      Precio del mazo (CK): {formatter.formatNumber(total)} USD
      {/* A total that silently omits cards no tracked store carries would read as
          complete when it isn't. */}
      {cardsWithoutPrice > 0 && (
        <span className="text-gray-400"> ({cardsWithoutPrice} sin precio)</span>
      )}
    </p>
  );
};

export default DeckPrice;
